import { MouseEvent } from 'react';

import { isDebugMode } from 'approot/shared/debug';

const loadingImages: { [url: string]: Promise<void> } = {};

const onError = (e: Event | string) => {
  if (isDebugMode()) {
    console.warn(`Problem loading image`, e);
  }
};

export const ALWAYS_RESOLVE_AFTER_MILLISECONDS = 5000;

export const preloadImage = (url: string): Promise<void> => {
  if (!loadingImages[url]) {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = url;
    // Stores the promise to loadingImages to ensure that Image()
    // isn't garbage collected and that any inflight network request
    // isn't canceled
    loadingImages[url] = new Promise(resolve => {
      const resolveWrapper = () => {
        if (timer) clearTimeout(timer);
        resolve();
      };
      let timer = setTimeout(resolveWrapper, ALWAYS_RESOLVE_AFTER_MILLISECONDS);
      image.onload = resolveWrapper;
      image.onerror = onError;
    });
  }
  return loadingImages[url];
};

export const isKeyboardModifierClick = (e: MouseEvent): boolean => {
  return e && (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey);
};

export const isNonSafariIOS = () => {
  const UA = window.navigator.userAgent;
  return (
    /(iPad|iPhone|iPod)/i.test(UA) &&
    /WebKit/i.test(UA) &&
    !/Version\//i.test(UA)
  );
};
